import { Component, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
//import * as Excel from "exceljs";
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';

@Component({
  selector: 'app-format-service',
  templateUrl: './format-service.component.html',
  styleUrls: ['./format-service.component.scss']
})
export class FormatServiceComponent implements OnInit {

  constructor(public authService: AuthService, private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private router: Router) {
    //console.log(localStorage.getItem("actividad_nombre"));    
   }
   id_raci;
   rel_pa;
   ls_area(){
      
  }
  ngOnInit() {
    var t= localStorage.getItem("t_raci");
    switch (t) {
      case 'P':
        this.Pgg4();
        break;
      case 'X':
        this.generateExcel();
          break;    
      default:
        break;
    }
    
  }

  async generateExcel() {
    
    //Excel Title, Header, Data
    
    //Create workbook and worksheet
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Car Data');
    //Add Row and formatting
    const title = 'Services-Catalog ';
    
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }
    worksheet.addRow([]);
    //let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')])
    //Add Image
    /*let logo = workbook.addImage({
      base64: logoFile.logoBase64,
      extension: 'png',
    });
    worksheet.addImage(logo, 'E1:F3');
    */
    worksheet.mergeCells('A1:D2');
    //Blank Row 
    worksheet.addRow([]);
    //Add Header Row
    var raciname;    
    let postData1 = {
      id:localStorage.getItem("id_raci")
    }
    await this.authService.service("/api/get_raci_id",postData1)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);                    
        raciname=res[0].descipcion;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });

    const header = [raciname];
    const header2 = ["Description"];
    this.tarea=[];
    let postData = {
      id_raci:localStorage.getItem("id_raci")
    }
    await this.authService.service("/api/get_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);  
          header.push(res[i].Titulo);   
          header2.push(res[i].Descripcion);   
          this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
          );
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });

    let headerRow = worksheet.addRow(header);
    let headerRow2 = worksheet.addRow(header2);
    
    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '8063A1' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.font={ color:{argb:"FFFFFF"} ,size: 12};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    headerRow2.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '8d8d8d' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    this.area=[];
    await this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);  
          this.area.push({ id:res[i].id,area:res[i].area,idx:res[i].idx});        
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
         // swal.fire('¡Información incorrecta!', '', 'error');
    });


    this.rel_pa=[];      
    await  this.authService.service("/api/get_pa_2",postData)
   .then(
       data => {
         var dat = JSON.stringify(data);
         var res = JSON.parse(dat);             
         for(var i=0;i<res.length;i++){
           //console.log(res[i]);         
           this.rel_pa.push(
               {id:res[i].id,
               id_p:res[i].id_tarea,
               id_a:res[i].id_area,
               rol:res[i].rol,
               c:"X"});
         }
         //console.log(res); 
         //this.load_rasci(); 
         //console.log(this.rel_pa);        
       },
       error => {
           var de= JSON.stringify(error);
           var di = JSON.parse(de)
           //swal.fire('¡Información incorrecta!', '', 'error');
    });  
 
    console.log(this.area);
    const data = [];
    for(let i=0;i<this.area.length;i++){
      var d=[];
      d.push(this.area[i].area);
      for(let j=0;j<this.tarea.length;j++){
        var bnd=0;
        var rol="";
        for(let k=0;k<this.rel_pa.length;k++){
          if(this.rel_pa[k].id_p==this.tarea[j].id  &&  this.rel_pa[k].id_a==this.area[i].id){
            bnd=1;
            rol=this.rel_pa[k].rol;           
          }          
        }     
        d.push(rol);
      }
      data.push(d)
    }    
    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
      
      row.eachCell((cell, number) => {
        if(cell.value=="X"){
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '555555' },
            
          }
          cell.font={ color:{argb:"FFFFFF"} ,size: 12};
          cell.alignment={horizontal:"center"}
                
        }else{
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' },
            bgColor: { argb: 'FF0000FF' }
          }
          
        } 
        cell.border = { top: { style: 'thin' , color: {argb:'000000'} }, 
            left: { style: 'thin' , color: {argb:'000000'} }, 
            bottom: { style: 'thin' }, 
            right: { style: 'thin', color: {argb:'000000'} } } ;      
      });


      let qty = row.getCell(1);
      let color = 'cccccc';
      /*if (+qty.value < 500) {
        color = 'FF9999'
      }*/
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    }
    );

    worksheet.getColumn(1).width = 50;
    //worksheet.getColumn(3).width = 30;
    //worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);
    //Footer Row
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    })
    setTimeout(function(){
      window.close();
    },4000);
  }
  cve=0;
  area;
  tarea;
  async Pgg4() {

    var tothoras=0;
    var totavance=0;

    //console.log("aqui");

    var contador=0;     
    const pdf = new PdfMakeWrapper();
    
    //pdf.background(  {image: this.img_g4,  width: 612,height:792    });

    pdf.pageSize('TABLOID')
     /* {
      width: 595.28,
      height: 'auto'
    });*/


    
    pdf.pageOrientation("landscape");  
   
    let postData2 = {
      id:localStorage.getItem("id_cliente")
    }
    var client_name;
    await this.authService.service("/api/get_cliente_byid",postData2)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        console.log(res[0]);  
        client_name=res[0].razonsocial;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
    

    let postData1 = {
      id:localStorage.getItem("id_raci")
    }
    var raciname;    
    await this.authService.service("/api/get_raci_id",postData1)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);                    
        raciname=res[0].descipcion;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
      
   pdf.add(new Txt("Services-Catalog ")
      .alignment('center').color("black").bold().fontSize(16).end);  
      pdf.add(new Txt( " ").alignment('left').color("black").bold().fontSize(18).end);  
   
      pdf.add(new Table([             
        [{text:"Company: "+client_name}, 
        {text:" ",color:"red",alignment:'right'}], 
       ]).widths([540,540]).layout('noBorders').fontSize(16).bold().alignment('left').end);
    
       /*
      pdf.add(new Txt( client_name).alignment('left').color("black").bold().fontSize(18).end);  
    pdf.add(new Txt("Title: "+raciname).alignment('left').color("red").bold().fontSize(18).end);  
    //pdf.pageMargins([35, 80, 35, 60]);  */

    let postData = {
      id_raci:localStorage.getItem("id_raci")
    }
    console.log(postData);
    
  
    this.tarea=[];
    await this.authService.service("/api/get_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);            
          this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
          );
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
    //this.area=[{" "," "," "," "}]
    var rows_=(this.tarea.length+1);
    var row_i=Math.ceil(950/rows_);
    var wdt_=[];
    for(var i=0;i<rows_;i++){
      wdt_.push(row_i);
    }
    //console.log(wdt_);
    //console.log("wdt");
    
    var column1 =new Array(); 
    pdf.styles({
      section: {
             }});
    column1.push({ text: raciname,color:'#FFFFFE',fillColor:'#8063A1'
        ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    for(var i=0;i<(this.tarea.length);i++){
      //console.log(this.tarea[i]);            
      column1.push({ text: this.tarea[i].proceso,color:'#FFFFFE',fillColor:'#8063A1',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    }
    pdf.add(new Table(
      [               
      column1      
      ]
    ).widths(wdt_).decorationColor("#000000").style("section").fontSize(11).bold().alignment('left').end);
    
    var column2=new Array();      
    column2.push({ text: 'Description',color:"#000000",fillColor:"#8d8d8d",fontsize:10,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    for(var i=0;i<(this.tarea.length);i++){
      column2.push({ text: this.tarea[i].descripcion,color:"#FFFFFE",fillColor:"#8d8d8d",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
    }
    pdf.add(new Table(
      [              
      column2     
      ]
    ).widths(wdt_).fontSize(9).alignment('left').end);
    
    this.area=[];
    await this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);  
          this.area.push({ id:res[i].id,area:res[i].area,idx:res[i].idx});        
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
         // swal.fire('¡Información incorrecta!', '', 'error');
      });

      this.rel_pa=[];      
     await  this.authService.service("/api/get_pa_2",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);             
          for(var i=0;i<res.length;i++){
            //console.log(res[i]);         
            this.rel_pa.push(
                {id:res[i].id,
                id_p:res[i].id_tarea,
                id_a:res[i].id_area,
                rol:res[i].rol,
                c:"X"});
          }
          //console.log(res); 
          //this.load_rasci(); 
          //console.log(this.rel_pa);        
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡Información incorrecta!', '', 'error');
        });  
  
    //console.log(this.area.length);
    for(var j=0;j<(this.area.length);j++){
      //console.log(this.area[j])
      var column3=new Array();      
      column3.push({ text:this.area[j].area,color:"#535442",fillColor:"#cccccc",fontSize:10 ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
      for(var i=0;i<(this.tarea.length);i++){
        var bnd=0;
        var rol="";
        for(let k=0;k<this.rel_pa.length;k++){
          if(this.rel_pa[k].id_p==this.tarea[i].id  &&  this.rel_pa[k].id_a==this.area[j].id){
            bnd=1;
            rol=this.rel_pa[k].rol;           
          }          
        }        
        switch (rol) {
          case 'X':column3.push({ text: rol,color: '#000000',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
            break;
          default:column3.push({ text:"",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});break;
        }                
      }
      pdf.add(new Table(
        [               
          column3    
        ]
      ).widths(wdt_).bold().alignment('left').end);
    }
    pdf.create().download();  
    setTimeout(function(){
      window.close();
    },4000);    
    }
}
